import { render, staticRenderFns } from "./NewsCards.vue?vue&type=template&id=cec49652&scoped=true&"
import script from "./NewsCards.vue?vue&type=script&lang=js&"
export * from "./NewsCards.vue?vue&type=script&lang=js&"
import style0 from "./NewsCards.vue?vue&type=style&index=0&id=cec49652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec49652",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VContainer,VFlex,VImg})
